import immutable from 'immutable'
// import Guid from 'guid' //Moved GUID to Search results to facilitate add/remove with a refresh

import {
    ADD_TRANSPORTATION,
    REMOVE_TRANSPORTATION,
    UPDATE_TRANSPORTATION_RESERVATION,
} from '../planner/planner.action'

export default (state, action) => {
    switch (action.type) {
        case ADD_TRANSPORTATION:
            // Need to neuter these to just what we need as they have a lot of extra data
            let newDepCity = null
            let newArrCity = null
            if (action.depCity) {
                newDepCity = immutable.fromJS({
                    'id': action.depCity.get('id'),
                    'name': action.depCity.get('name'),
                    'opencage': action.depCity.get('opencage')
                })
            }
            if (action.arrCity) {
                newArrCity = immutable.fromJS({
                    'id': action.arrCity.get('id'),
                    'name': action.arrCity.get('name'),
                    'opencage': action.arrCity.get('opencage')
                })
            }
            let newItem = immutable.fromJS({
                'legDep': action.depLeg,
                'legArr': action.arrLeg,
                'destDep': newDepCity,
                'destArr': newArrCity,
                'transportation': action.transportation,
                'added_by': action.user.firstname
            })
            return state.push(newItem)
        case REMOVE_TRANSPORTATION:
            let deleteIdx = state.findIndex((trans) => {
                return trans.getIn(['transportation', 'transportation_guid']) === action.transportation.get('transportation_guid')
            })
      
            return state.delete(deleteIdx)
        case UPDATE_TRANSPORTATION_RESERVATION:
            // TODO: Is this the right way to do this? Basically just overwriting the whole object as multiple things may have changed
            let transIdx = state.findIndex((trans) => {
                return trans.getIn(['transportation', 'transportation_guid']) === action.transportation.get('transportation_guid')
            })

            let newObject = immutable.fromJS({
                'legDep': action.depLeg,
                'legArr': action.arrLeg,
                'destDep': newDepCity,
                'destArr': newArrCity,
                'transportation': action.transportation,
            })

            return state.update(transIdx, (trans) => {
                return trans.mergeDeep(newObject)
            })

        default:
            return state
    }
}
